export const formatDate = (value: Date, withTime: boolean) => {
    const year = value.getFullYear();
    const month = value.getMonth() + 1;
    const day = value.getDate();
    const d = day < 10 ? `0${day}` : day;
    const m = month < 10 ? `0${month}` : month;
    const date = `${d}.${m}.${year}`;
    if (withTime) {
        var hours = value.getHours();
        var minutes = value.getMinutes();
        var min = minutes < 10 ? `0${minutes}` : minutes;
        return `${date}, ${hours}:${min}`;
    }
    return date;
}

export const formatTableDate = (value: Date) => {
    return toTableFormattedDate(value);
}

export const toTableFormattedDate = (value: Date) => {
    return toFormattedDate(value);
}

export const toQueryDate = (value: Date) => {
    const date = toFormattedDate(value);
    const hour = value.getHours();
    return `${date} ${hour}:00:00`;
}

export const toUtcQueryDate = (value: Date) => {
    const date = toUtcFormattedDate(value);
    const hour = value.getUTCHours();
    return `${date} ${hour}:00:00`;
}

export const toFormattedDate = (value: Date) => {
    const year = value.getFullYear();
    const month = value.getMonth() + 1;
    const day = value.getDate();
    const m = month < 10 ? `0${month}` : month;
    const d = day < 10 ? `0${day}` : day;
    return `${year}-${m}-${d}`;
}

export const toUtcFormattedDate = (value: Date) => {
    const year = value.getUTCFullYear();
    const month = value.getUTCMonth() + 1;
    const day = value.getUTCDate();
    const m = month < 10 ? `0${month}` : month;
    const d = day < 10 ? `0${day}` : day;
    return `${year}-${m}-${d}`;
}

export const formattedDate = (value: Date) => {
    return value.toISOString().split("T")[0];
}

export const getUtcAgo = (days: number) => {
    const date = getDateAgo(days);
    return getUtc(date);
}

export const getUtc = (value: Date) => {
    const year = value.getFullYear();
    const month = value.getMonth();
    const day = value.getDate();
    return new Date(Date.UTC(year, month, day, 0, 0, 0));
}

export const getDateAgo = (days: number) => {
    return new Date(Date.now() - days * 24 * 3600 * 1000)
}

export const currentYear = () => {
    const year = new Date().getFullYear();
    return year;
}